module.exports = __webpack_public_path__ + "img/e59cd8b.png";